// extracted by mini-css-extract-plugin
export var extra = "extra-module--extra--29740";
export var extra__btn = "extra-module--extra__btn--4019f";
export var extra__container = "extra-module--extra__container--851de";
export var extra__item = "extra-module--extra__item--c6ff2";
export var extra__list = "extra-module--extra__list--6ca73";
export var extra__methods = "extra-module--extra__methods--bcec9";
export var extra__methodsImg = "extra-module--extra__methods-img--78705";
export var extra__methodsInfo = "extra-module--extra__methods-info--88655";
export var extra__methodsTxt = "extra-module--extra__methods-txt--aab2b";
export var extra__methodsTxt_main = "extra-module--extra__methods-txt_main--cd9b9";
export var extra__text = "extra-module--extra__text--6f741";